import { a as s, w as i } from "./lit-element-6iugfgmM.js";
import { i as n, t as o, e as a } from "./directive-B5s9Ooqi.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class e extends n {
  constructor(t) {
    if (super(t), this.it = s, t.type !== o.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === s || t == null) return this._t = void 0, this.it = t;
    if (t === i) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const r = [t];
    return r.raw = r, this._t = { _$litType$: this.constructor.resultType, strings: r, values: [] };
  }
}
e.directiveName = "unsafeHTML", e.resultType = 1;
const l = a(e);
export {
  e,
  l as o
};
//# sourceMappingURL=unsafe-html-BQFfCuri.js.map
